<template>
  <div>
    <b-form-group class="contenedor_maps">
      <b-form-radio-group buttons   aria-describedby="ariaDescribedby">
        <div class="contenedor_maps">
          <b-radio class="btnAceptar" name="rbSinaloa" button-variant="outline-success" v-on:change="sbSinaloa" value="true">SINALOA</b-radio>
          <b-radio  class="btnAceptar" button-variant="outline-success"  v-on:change="sbBaja" value="false">BAJA CALIFORNIA SUR</b-radio>
        </div>
        </b-form-radio-group>
    </b-form-group>

    <b-form-group class="contenedor_grupo" label="Estación:" label-for="estacion">
      <b-form-text class="tarjeta_cuerpo" id="estacion" type="text" >
        {{ estacion }} / {{ direccion }}
      </b-form-text>
    </b-form-group>

    <GmapMap
      :center='center'
      :zoom='8'
      style='width:100%;  height: 26rem;'
    >
        
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true" 
        @click="addm(m.position)"            
      />
    </GmapMap>
  </div>
</template>
  
<script>
export default {
  name: 'GoogleMap',
    data() {
      return {
        center: { lat: 24.802454103179883, lng: -107.41319673403153 },
        currentPlace: null,
        markers: [],
        places: [],
        estacion: '',
        direccion: '',
      }
    },
    
    mounted() {
      // this.geolocate();
      this.addMarker();
      
    },
     
    methods: {
      setPlace(place) {
        this.currentPlace = place;
      },
      addm (item) {
        this.estacion = item.idEstacion
        this.direccion = item.title + " / "  +  item.adreess
        localStorage.estacion =    this.estacion
        localStorage.direccionEstacion =  this.direccion
      },

    sbSinaloa() {
      navigator.geolocation.getCurrentPosition(
        this.center = {
          lat: 24.802454103179883,
          lng: -107.41319673403153,
        }
      )       
    },
  
    sbBaja() {
      navigator.geolocation.getCurrentPosition(
        this.center = {
          lat: 24.124439030379662,
          lng: -110.31127307605436,
        }
      )       
    },
  
    addMarker() {

      const congreso = {
        lat: 24.802454103179883,
        lng: -107.41319673403153,
        idEstacion: "4120",
        title: "CONGRESO",
        adreess: "Blvd. Pedro Infante 1846-Local15, Desarrollo Urbano Tres Ríos, 80020 Culiacán Rosales, Sin." 
      }
  
      /* baja */
      const miraFlores = {
        lat:  23.370166641789314,
        lng: -109.75272749792795,
        idEstacion: "1700",
        title: "MIRA FLORES",
        adreess: "San José del Cabo-Lapaz km 72, Miraflores, B.C.S."
      } 
      
      const olachea = {
        lat:   24.139515768582505,
        lng: -110.31698758744565,
        idEstacion: "7416",
        title: "OLACHEA",
        adreess: "Gral Félix Ortega Aguilar 3215, Pueblo Nuevo, 23060 La Paz, B.C.S."
      } 
  
      const cdconstitucion = {
        lat: 25.061080723795612,
        lng: -111.6868830643563,
        idEstacion: "4036",
        title: "CD. CONSTITUCION",
        adreess: "México 1 km 214, Longoria, 23620 Cdad. Constitución, B.C.S."
      } 
  
      const staRosa = {
        lat: 23.093936750100408,
        lng: -109.70891986901675,
        idEstacion: "1705",
        title: "SANTA ROSA",
        adreess: "Carretera Transpeninsular, Km 36+400 San José del Cabo, B.C.S."
      } 
      
      /* SINALOA */
      const navolato = {
        lat:  24.762361931025794,
        lng: -107.69843335979388,
        idEstacion: "9084",
        title: "NAVOLATO",
        adreess: "Chevron, Benito Juárez, Las Vegas, 80324 Navolato, Sin."
      } 
  
      const villaJuarez = {
        lat:  24.66209095868476,
        lng: -107.52244435543831,
        idEstacion: "9187",
        title: "VILLA JUAREZ",
        adreess: "Chevron, 80378 Lic. Benito Juárez, Sin."
      } 
  
      const costaRica = {
        lat:  24.589827669177662,
        lng: -107.39972451523833,
        idEstacion: "6555",
        title: "COSTA RICA",
        adreess: "Costa Rica, Sinaloa, 80430 Costa Rica, Sin."
      } 
  
      const elDorado = {
        lat:  24.332198991590758,
        lng: -107.37006030610982,
        idEstacion: "4340",
        title: "EL DORADO",
        adreess: "Chevron Eldorado, 80450 Eldorado, Sin."
      } 
  
      const rioElota = {
        lat:  23.919030656328257,
        lng: -106.88845450601286,
        idEstacion: "1777",
        title: "RÍO ELOTA",
        adreess: "GRUPO HORIZON GASOLINERAS - LA CRUZ, Av Pte 7 #100, Centro, 82700 La Cruz, Sin."
      } 
 
          // const tamazula = {
          // lat:  25.477311916061474,
          // lng: -108.16347473999357,
          // idEstacion: "8345",
          // title: "TAMAZULA",
          // adreess: "Salvador Alvarado, 81520 Sin."
          // } 
  
          
      const hidrocarburos = {
        lat:  25.461673375947562,
        lng: -108.07936881705999,
        idEstacion: "9672",
        title: "HIDROCARBUROS",
        adreess: "Av Mariano Matamoros Nte 50, Juárez, 81450 Guamúchil, Sin."
      } 
   
      this.markers.push({ position: congreso },{position: miraFlores}, {position: olachea}, {position: cdconstitucion} ,
      {position: navolato},{position: villaJuarez},{position: costaRica},{position: elDorado},
      {position: rioElota}, {position: navolato} ,  {position: staRosa} ,{position: hidrocarburos});
      },

      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        });
      }
    }
  };
</script>

<style scoped>
.contenedor_maps,
.btnAceptar{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  gap: 15px;
}

.btnAceptar{
  border-radius: 10px;
  margin: 0;
  height: 30px;
  gap: 0;
}

.text-muted{
  color: #000 !important;
}
</style>